import React from "react";
import { Form, Formik } from "formik";
import { CHANGE_PASSWORD_VALIDATION_SCHEMA } from "../../../js/constants/validationSchemas";
import { openModal } from "../../../app/common/modals/modalReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  signOutFirebase,
  updateUserPassword,
} from "../../../app/firestore/firebaseService";
import { CHANGE_PASSWORD_SUCCESS_MODAL } from "../../../app/common/modals/ModalManager";
import MyPasswordInput from "../../../app/common/form/MyPasswordInput";
import { HOME_PAGE_ROUTE } from "../../../app/api/routeConstants";
import { signOutUser } from "../authActions";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { confirmPasswordReset } from "firebase/auth";
import { Button } from "semantic-ui-react";

export default function ChangePasswordForm({ auth = null, actionCode = "" }) {
  const { currentUserAccount } = useSelector((state) => state.account);

  const dispatch = useDispatch();
  const history = useHistory();

  async function handleSignOut() {
    try {
      history.push(HOME_PAGE_ROUTE);
      dispatch(signOutUser());
      await signOutFirebase();
    } catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <Formik
      initialValues={{ newPassword1: "", newPassword2: "" }}
      validationSchema={CHANGE_PASSWORD_VALIDATION_SCHEMA}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        try {
          if (currentUserAccount) {
            await updateUserPassword(values);
          } else {
            await confirmPasswordReset(auth, actionCode, values.newPassword2);
          }
          await handleSignOut();
          dispatch(
            openModal({
              modalType: CHANGE_PASSWORD_SUCCESS_MODAL,
            })
          );
        } catch (error) {
          setErrors({ auth: error.message });
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ errors, isSubmitting, isValid, dirty, values }) => (
        <Form className="ui form">
          <MyPasswordInput
            name="newPassword1"
            labelText={<div className="body-blue-text">New password</div>}
          />
          <MyPasswordInput
            name="newPassword2"
            labelText={
              <div className="body-blue-text">Re-enter your new password</div>
            }
            containerStyle={{ marginTop: 33 }}
          />
          <Button
            className="overwrite-button cta-orange-form"
            content={"Change password"}
            type={"submit"}
            style={{ margin: "35px 0 0 0" }}
            loading={isSubmitting}
            disabled={
              values.newPassword1 !== values.newPassword2 ||
              !isValid ||
              !dirty ||
              isSubmitting
            }
          />
          {currentUserAccount && errors.auth && (
            <div
              className="error-message"
              style={{
                fontSize: 13,
                marginBottom: 10,
                marginTop: 10,
              }}
            >
              For security reasons, you need to have recently signed in to
              change your password. Please sign in again to complete this
              action.
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
}
